<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <Caption label="먼데이리스 견적의 장점"></Caption>
        </div>

        <p style="font-weight: 300; font-size: 28px;margin-top: 50px;">
          먼데이리스는 <span style="color: #215FE6;">기술력</span>과 <span style="color: #215FE6;">효율적인 개발방식</span>으로<br/> 원가를 절감하여 이를 고객과
          나눕니다.
        </p>
        <p style="font-weight: 500; font-size: 32px;margin-top: 20px;margin-bottom: 80px;">
          먼데이리스에 투입하시는 금액이 가장 효율적입니다
        </p>
        <img width="751" class="pc" src="@/assets/images/main_graph.png" />
        <img width="288" class="mobile" src="@/assets/images/main_graph_mobile.png" />
        
        <p style="font-weight: 300; font-size: 24px; margin-top: 50px;">
          먼데이리스는 평균 시장가의 80%의 견적을 드립니다.
        </p>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionGreen,
  },
  mounted() {},
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #ffffff;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

.bbb {
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  margin-bottom: 150px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    padding-left: 40px;
    padding-right: 40px;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #ffffff;
  }

  .content {
    width: 100%;
    text-align: center;
  }

  .bbb {
    text-align: center;
    display: inline-block;
    justify-content: space-between;
    margin-top: 100px;
    margin-bottom: 150px;
  }
}
</style>
  